import { BarChart } from "@msuite/ui/charts";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import type { GetInvoiceStatisticsQuerySchema } from "@msuite/utils/schemas";
import { useInvoiceStatistics } from "@/hooks/use-invoice-statistics";

/** Props Interface */
interface InvoiceStatisticsChartProps {
	query: GetInvoiceStatisticsQuerySchema;
	mode?: "sum" | "cumulative";
}

export function InvoiceStatisticsChart({ query, mode = "sum" }: InvoiceStatisticsChartProps) {
	/** Query */
	const { statistics } = useInvoiceStatistics(query);

	/** Render */
	return (
		<BarChart
			data={guardArray(statistics).map((stat) => ({
				name: moment(stat.dateIdentifier).dbWeek(),
				sum: stat.sum,
				cumulative: stat.cumulative - stat.sum,
			}))}
			dataKeys={mode === "cumulative" ? ["sum", "cumulative"] : ["sum"]}
			displayKeyMap={{
				sum: "Summe",
				cumulative: "Kumulativ",
			}}
			xHidden
			formatter={(val) => formatNumber(val, "currency")}
			isStack
		/>
	);
}
